import { lazy } from 'react';
import { createBrowserRouter, useNavigate, Navigate } from 'react-router-dom';
import { Layout } from '../layout/Layout';
import { ErrorPage } from '@tasama/ui';
import { ONBOARDING_ROUTES } from '@tasama/config';
import { AppErrorPage } from '../pages';

// Route-level page components — lazy-loaded for code splitting
const AppInfoPage = lazy(() =>
  import('../pages/AppInfoPage').then((m) => ({
    default: m.AppInfoPage,
  }))
);

const NotFoundWrapper = () => {
  const navigate = useNavigate();

  return (
    <ErrorPage
      variant="not-found"
      testID="onboarding-404"
      onHomeClick={() => navigate(ONBOARDING_ROUTES.ROOT)}
      onBackClick={() => navigate(-1)}
    />
  );
};

const router = createBrowserRouter([
  {
    // Pathless root route — global error boundary for the entire onboarding app.
    // React Router catches errors here before its built-in crash screen is shown.
    errorElement: <AppErrorPage />,
    children: [
      {
        path: '/',
        element: <Navigate to={ONBOARDING_ROUTES.ROOT} replace />,
      },
      {
        path: ONBOARDING_ROUTES.ROOT,
        element: <Layout />,
      },
      {
        path: ONBOARDING_ROUTES.APP_INFO,
        element: <AppInfoPage />,
      },
      {
        path: '*',
        element: <NotFoundWrapper />,
      },
    ],
  },
]);

export { router };
